export const contactsData = {
  email: "mydearsainathkadam@gmail.com",
  phone: "+91 7887765249",
  address: "Pune Maharashtra ",

  sheetAPI: "",
};
